export default __webpack_public_path__ + "static/media/rgs_cube.6e4d8a3a.jpg";